// Escuro ou claro, lembrado onde o legado lembra (`orren_theme`), pra troca
// de painel não trocar o tema. O atributo vai na raiz do documento: é o que
// os tokens leem.
import { createContext, useCallback, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';

export type Tema = 'dark' | 'light';
const CHAVE = 'orren_theme';

function temaInicial(): Tema {
  try { return localStorage.getItem(CHAVE) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

const Contexto = createContext<{ tema: Tema; alternar(): void }>({ tema: 'dark', alternar() {} });

export function TemaProvider({ children }: { children: ReactNode }) {
  const [tema, setTema] = useState<Tema>(temaInicial);
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    try { localStorage.setItem(CHAVE, tema); } catch { /* modo anônimo */ }
  }, [tema]);
  const alternar = useCallback(() => setTema((t) => (t === 'dark' ? 'light' : 'dark')), []);
  const valor = useMemo(() => ({ tema, alternar }), [tema, alternar]);
  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>;
}

export const useTema = () => useContext(Contexto);
